import _ from 'lodash';

export function findISCombinations(height: number, count: number) {
  /**
   * Compute the heights we should use for IS
   * Should be centered
   * Standard size: [125, 175, 225]
   */
  if (
    (count === 1 && height - 50 <= count * 125) ||
    height - 50 <= count * 125
  ) {
    return null;
  }

  const refValue = height / (count + 1);
  let minimum = height;
  let currentISHeight = 125;
  for (const standardISHeight of [125, 175, 225]) {
    const gap = Math.abs(standardISHeight - refValue);
    if (gap < minimum) {
      minimum = gap;
      currentISHeight = standardISHeight;
    }
  }

  const result: number[] = [];
  for (const value of _.range(count)) {
    result.push(currentISHeight);
  }

  return result;
}
